/** @format */

import { ActivatedRouteSnapshot, Params, Resolve } from '@angular/router';
import { KillswitchService, UtilityService } from '@shared/data-access/services';

import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { catchError, tap } from 'rxjs/operators';
import { Store } from '@ngrx/store';

import { chain } from '@core/chain';
import { ReviewReturn } from './../model/review.interface';
import { ReviewService } from '../service/review.service';
import { setProductReviewState } from '../+state';

@Injectable({
	providedIn: 'root'
})
export class ProductReviewsResolver implements Resolve<ReviewReturn> {
	reviewsSEOServer = false;
	reviewsSEOClient = false;
	isNewReviewsEnabled = false;
	productIdentifier: string;

	constructor(
		private utilityService: UtilityService,
		private killSwitchService: KillswitchService,
		private reviewService: ReviewService,
		private ngrxStore: Store
	) {
		this.killSwitchService.getKillSwitchesEnvironment$().subscribe((data) => {
			this.reviewsSEOServer = this.utilityService.checkKillSwitch(
				'reviewsSEOServer',
				data,
				chain.chainIdentifierAbbr
			);
			this.reviewsSEOClient = this.utilityService.checkKillSwitch(
				'reviewsSEOClient',
				data,
				chain.chainIdentifierAbbr
			);
			this.isNewReviewsEnabled = this.utilityService.checkKillSwitch(
				'isNewReviewsEnabled',
				data,
				chain.chainIdentifierAbbr
			);
		});
	}

	resolve(route: ActivatedRouteSnapshot): Observable<ReviewReturn | null> {
		this.productIdentifier = this.getProductIdentifierFromRoute(route.params);
		if (!!this.productIdentifier && (this.reviewsSEOClient || this.reviewsSEOServer)) {
			const options = this.isNewReviewsEnabled
				? { sortBy: 'SubmissionTime:desc', limitTo: 5 }
				: { sortBy: 'SubmissionTime:desc', limitTo: 15 };
			return this.reviewService.getReviews$(this.productIdentifier, options).pipe(
				tap((reviewResponse) => {
					this.ngrxStore.dispatch(
						setProductReviewState({
							productIdentifier: this.productIdentifier,
							reviewSummary: reviewResponse.reviewSummary,
							reviews: reviewResponse.reviews,
							product: reviewResponse.product
						})
					);
				}),
				catchError(() => of(null))
			);
		} else {
			return of(null);
		}
	}

	private getProductIdentifierFromRoute(routeParams: Params): string {
		return routeParams['partNumber'] ? routeParams['partNumber'] : '';
	}
}
